import FilePickerActionsPanelViewState from '../../store/schema/FilePickerActionsPanelViewState';
import { action } from 'satcheljs/lib/legacy';

export const hide = action('hideFilePickerActionsPanel')(function hideFilePickerActionsPanel(
    viewState: FilePickerActionsPanelViewState
) {
    viewState.isOpen = false;
});

export const show = action('showFilePickerActionsPanel')(function showFilePickerActionsPanel(
    viewState: FilePickerActionsPanelViewState
) {
    viewState.isOpen = true;
});
